import {
    IDocumento,
    IDocumentoCreate,
} from "../../../Interfaces/Geral/CasoDocumentos/CasoDocumentosInterface";
import {
    AtualizarDocumentoService,
    DeletarDocumentoService,
    GetDocumentoUAUService,
    InserirDocumentoDiretoEmCasoService,
    ListarCasoDocumentoPorContaService,
    ListarCasoDocumentoPorContaUAUService,
    ListarCasoDocumentoService,
} from "../../../Services/Geral/CasoDocumentos/CasoDocumentosService";
import { ValidationErr } from "../../../Validations/ValidationError";

import { Controller } from "../../Controller";

export async function ListarCasoDocumentoController(IDCaso: number) {
    return Controller(ListarCasoDocumentoService(IDCaso));
}

export async function GetDocumentoUAUController(requestBody: IDocumento) {
    const response = await GetDocumentoUAUService({
        ...requestBody,
        DS_LINK_DRIVE: requestBody.DS_LINK_DRIVE?.replaceAll("\\\\", "\\"),
    })
        .then((response) => {
            return {
                response: response.data,
                contentType: response.headers["content-type"],
            };
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });

    return response;
}

export async function DeletarDocumentoController(ID_CASO_DOCUMENTO: number) {
    return Controller(DeletarDocumentoService(ID_CASO_DOCUMENTO));
}

export async function AtualizarDocumentoController(requestBody: IDocumento) {
    return Controller(AtualizarDocumentoService(requestBody));
}

export async function InserirDocumentoDiretoEmCasoController(
    requestBody: IDocumentoCreate
) {
    return Controller(InserirDocumentoDiretoEmCasoService(requestBody));
}

export async function ListarCasoDocumentoPorContaController(idConta: number) {
    return Controller(ListarCasoDocumentoPorContaService(idConta));
}

export async function ListarCasoDocumentoPorContaUAUController(
    idConta: number
) {
    return Controller(ListarCasoDocumentoPorContaUAUService(idConta));
}
